import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { DataBlocks, I18n } from 'components';
import { formatUnitString, formatDate } from 'utils/formatString';

import styles from '../styles.pcss';
const cx = classNames.bind(styles);

const BalancesRow = ({
  nameText,
  dueDate,
  unit,
  value,
}) => (
  <DataBlocks.TableRow>
    <DataBlocks.TableCell>
      {nameText}
    </DataBlocks.TableCell>
    <DataBlocks.TableCell className={cx('noWrapCell')}>
      <I18n
        path="home.additionalBalances.rest"
        vars={{
          rest: unit === 'KBYTE'
            ? formatUnitString(value / 1024, unit)
            : formatUnitString(value, unit),
        }}
      />
    </DataBlocks.TableCell>
    <DataBlocks.TableCell className={cx('noWrapCell')}>
      {dueDate ? (
        <I18n
          path="home.additionalBalances.dueDate"
          vars={{ duedate: formatDate(dueDate) }}
        />
      ) : (
        <I18n path="home.additionalBalances.noDueDate" />
      )}
    </DataBlocks.TableCell>
  </DataBlocks.TableRow>
);

BalancesRow.propTypes = {
  nameText: PropTypes.string,
  unit: PropTypes.string,
  value: PropTypes.number,
  dueDate: PropTypes.string,
};

export default BalancesRow;
